import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { FAQS } from "../data/siteData";

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-16 md:py-24 bg-[#F4F8FC]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <p className="text-s font-bold uppercase tracking-[0.2em] text-[#0066FF]">FAQ</p>
          <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#0B1F44]">
            Common questions about commercial energy procurement
          </h2>
        </div>

        <div className="mt-12 space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                data-testid={`faq-accordion-item-${i}`}
                className={`rounded-2xl border bg-white transition-colors ${
                  isOpen ? "border-[#0066FF]/40 shadow-[0_10px_30px_-5px_rgba(11,31,68,0.08)]" : "border-slate-200"
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="font-semibold text-[#0B1F44] text-sm sm:text-base">{f.q}</span>
                  <ChevronDown
                    size={20}
                    className={`shrink-0 text-[#0066FF] transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`}
                  />
                </button>
                <div className={`acc-panel ${isOpen ? "open" : ""}`}>
                  <div>
                    <p className="px-6 pb-6 text-sm text-slate-600 leading-relaxed">{f.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
